import { useEffect } from 'react';
import { Alert, Badge, Button, Card, Group, List, Stack, Text } from '@mantine/core';
import { useSahaKuyrugu } from '../api/queries';
import { KUYRUK_ISLEM_ETIKET } from '../offline/saha-kuyrugu';

import { ANLAM } from '../theme';
import { zamanGoster } from '../lib/format';

/**
 * ÇEVRİMDIŞI KUYRUK PANELİ (F3·S5 cache-and-queue).
 *
 * İki şeyi görünür kılar, ikisi de sessiz kalamaz:
 *  1. **BEKLEYEN adımlar** — cihazda tutuluyor, henüz sunucuda değil.
 *  2. **SENKRON ÇATIŞMALARI** — sunucuya ulaştığında durum makinesinden
 *     geçemeyen adım (409/422/403). Kayıt DÜŞMEZ, listede durur: sahadaki
 *     kişi "yaptım sandığım şey olmamış" bilgisini almak zorundadır.
 *
 * Ağ geri geldiğinde senkron KENDİLİĞİNDEN denenir; elle tetik de vardır
 * (bağlantı geldi ama tarayıcı olayı kaçırdıysa kullanıcı beklemez).
 */
export function SahaKuyrukPaneli(): React.JSX.Element | null {
  const { kayitlar, catismalar, senkron, catismalariTemizle, senkronKosuyor } = useSahaKuyrugu();

  useEffect(() => {
    const cevrimiciOlunca = (): void => {
      void senkron();
    };
    window.addEventListener('online', cevrimiciOlunca);
    return () => window.removeEventListener('online', cevrimiciOlunca);
  }, [senkron]);

  if (kayitlar.length === 0 && catismalar.length === 0) return null;

  return (
    <Card withBorder data-testid="saha-kuyruk-paneli">
      <Stack gap="xs">
        {kayitlar.length > 0 && (
          <>
            <Group gap="xs">
              <Badge color={ANLAM.dikkat} data-testid="saha-kuyruk-sayaci">
                {kayitlar.length} adım cihazda bekliyor
              </Badge>
              <Button
                size="compact-xs"
                variant="light"
                data-testid="saha-kuyruk-senkron"
                loading={senkronKosuyor}
                onClick={() => void senkron()}
              >
                Şimdi senkronla
              </Button>
            </Group>
            <List size="sm" spacing={2}>
              {kayitlar.map((kayit) => (
                <List.Item key={kayit.id} data-testid="saha-kuyruk-satiri">
                  {KUYRUK_ISLEM_ETIKET[kayit.islem.tip]} · {zamanGoster(kayit.cihazAt)}
                </List.Item>
              ))}
            </List>
          </>
        )}

        {catismalar.length > 0 && (
          <Alert
            color={ANLAM.engel}
            title="Senkron çatışması"
            role="alert"
            data-testid="saha-catisma"
          >
            <Text size="sm">
              Aşağıdaki adımlar sunucuya ulaştığında iznin güncel durumuna uymadı ve KAYDEDİLMEDİ.
              Sahada yapılan iş ile sistemdeki kayıt ayrıştı — gerekirse yeniden yapın.
            </Text>
            <List size="sm" spacing={2} mt="xs">
              {catismalar.map((catisma) => (
                <List.Item key={catisma.id} data-testid="saha-catisma-satiri">
                  {KUYRUK_ISLEM_ETIKET[catisma.islem.tip]} · {zamanGoster(catisma.cihazAt)} —{' '}
                  {catisma.mesaj}
                </List.Item>
              ))}
            </List>
            <Button
              size="compact-xs"
              variant="default"
              mt="xs"
              data-testid="saha-catisma-temizle"
              onClick={catismalariTemizle}
            >
              Okudum, listeyi temizle
            </Button>
          </Alert>
        )}
      </Stack>
    </Card>
  );
}
